"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResponse = exports.NewCommentRequest = exports.PostRequest = exports.BlogRequest = exports.EnquiryRequest = void 0;
const validator = require('validate.js');
class EnquiryRequest {
    static validate(value) {
        return validator.async(value, enquiryConstraints);
    }
    constructor(message, name, email) {
        this.message = message;
        this.name = name;
        this.email = email;
    }
}
exports.EnquiryRequest = EnquiryRequest;
const enquiryConstraints = {
    email: {
        presence: true,
        email: true,
    },
    message: {
        presence: true,
        length: { minumum: 1 },
    },
    name: {
        presence: true,
        length: { minumum: 1 },
    },
};
class BlogRequest {
}
exports.BlogRequest = BlogRequest;
class PostRequest {
}
exports.PostRequest = PostRequest;
class NewCommentRequest {
    static validate(value) {
        return validator.async(value, newCommentConstraints);
    }
    constructor(text, name, email, postId) {
        this.text = text;
        this.name = name;
        this.email = email;
        this.postId = postId;
    }
}
exports.NewCommentRequest = NewCommentRequest;
const newCommentConstraints = {
    email: {
        presence: true,
        email: true,
    },
    text: {
        presence: true,
        length: { minumum: 1 },
    },
    postId: {
        presence: true,
        length: { minumum: 1 },
    },
    name: {
        presence: true,
        length: { minumum: 1 },
    },
};
class ErrorResponse {
    constructor(statusCode, output) {
        this.statusCode = statusCode;
        this.output = output;
    }
}
exports.ErrorResponse = ErrorResponse;
